import { LogLevel } from './LogLevel';
var ConsoleFunction = /** @class */ (function () {
    function ConsoleFunction(name, messagePrefix) {
        if (messagePrefix === void 0) { messagePrefix = false; }
        this.name = name;
        this.messagePrefix = messagePrefix;
    }
    ConsoleFunction.prototype.call = function (console, level, message, data) {
        var resultMessage = message;
        if (this.messagePrefix) {
            resultMessage = LogLevel[level] + ": " + message;
        }
        console[this.name](resultMessage, data);
    };
    ConsoleFunction.prototype.canBeCalled = function (console) {
        return console && (this.name in console);
    };
    return ConsoleFunction;
}());
var consoleFunctionsMap = {};
consoleFunctionsMap[LogLevel.Trace] = new ConsoleFunction('log');
consoleFunctionsMap[LogLevel.Debug] = new ConsoleFunction('log', true);
consoleFunctionsMap[LogLevel.Info] = new ConsoleFunction('info');
consoleFunctionsMap[LogLevel.Warn] = new ConsoleFunction('warn');
consoleFunctionsMap[LogLevel.Error] = new ConsoleFunction('error');
consoleFunctionsMap[LogLevel.Fatal] = new ConsoleFunction('error', true);
var defaultConsoleFunction = new ConsoleFunction('log', true);
var Logger = /** @class */ (function () {
    function Logger(console, minLogLevelToDisplay) {
        if (minLogLevelToDisplay === void 0) { minLogLevelToDisplay = LogLevel.Warn; }
        this.console = console;
        this.minLogLevelToDisplay = minLogLevelToDisplay;
    }
    Logger.prototype.canDisplayMessageFor = function (logLevel) {
        return this.console && this.minLogLevelToDisplay != null && this.minLogLevelToDisplay <= logLevel;
    };
    Logger.prototype.trace = function (message, data) {
        this.log(LogLevel.Trace, message, data);
    };
    Logger.prototype.debug = function (message, data) {
        this.log(LogLevel.Debug, message, data);
    };
    Logger.prototype.info = function (message, data) {
        this.log(LogLevel.Info, message, data);
    };
    Logger.prototype.warn = function (message, data) {
        this.log(LogLevel.Warn, message, data);
    };
    Logger.prototype.error = function (message, data) {
        this.log(LogLevel.Error, message, data);
    };
    Logger.prototype.fatal = function (message, data) {
        this.log(LogLevel.Fatal, message, data);
    };
    Logger.prototype.log = function (level, message, data) {
        if (!this.canDisplayMessageFor(level))
            return;
        var logFunction = consoleFunctionsMap[level];
        if (logFunction == null) {
            if (defaultConsoleFunction.canBeCalled(this.console)) {
                defaultConsoleFunction.call(this.console, LogLevel.Fatal, 'Unsupported log level', level);
            }
            else {
                return;
            }
            logFunction = defaultConsoleFunction;
        }
        else if (!logFunction.canBeCalled(this.console)) {
            if (!defaultConsoleFunction.canBeCalled(this.console))
                return;
            logFunction = defaultConsoleFunction;
        }
        logFunction.call(this.console, level, message, data);
    };
    Logger.prototype.enabledFor = function (level) {
        return this.canDisplayMessageFor(level);
    };
    return Logger;
}());
export var logger = new Logger(window.console, window.xmMinLogLevel);
//# sourceMappingURL=Logger.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/logging/Logger.js
// module id = 12
// module chunks = 1